import { CollideEvent, CollideId, TapCollider } from '../../defs/collide';
import {
  despawnBlockEntity,
  type RainbowBubbleBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { BreakEffect } from '../effects/BreakEffect';
import { CollideHandler, ICollision } from './ICollision';

export class RainbowBubbleCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: RainbowBubbleBlockEntity;
  private readonly resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this.resolveTap,
    attack: this.resolveAttack,
    block: this.resolveBlock,
  };

  constructor(scene: GameScene, entity: RainbowBubbleBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this.resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap(event: CollideEvent) {
    const cell = (event.collider as TapCollider).cell;
    const layer = cell.base;

    // Trigger tap collision on the block underneath the bubble
    layer?.entity.c.block.collide('tap', { type: 'tap', cell });
    return false;
  }

  private async resolveAttack() {
    await this.attack();
    return true;
  }

  private async resolveBlock(event: CollideEvent) {
    const collider = event.collider;
    // Attack only if basic block collider
    if (
      collider?.type === 'block' &&
      collider.entity.c.block.props.type === 'basic'
    ) {
      await this.attack();
      return true;
    }
    return false;
  }

  private async attack() {
    const position = this.entity.c.position.mapPosition;
    despawnBlockEntity(this.scene, this.entity);
    new BreakEffect(this.scene, {
      position,
      size: this.entity.c.block.props,
      color: 0xccef86,
      alpha: 0.3,
    }).execute();
  }
}
